import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {OrganizationVO} from '../../../../generate/OrganizationVO';
import {ChangeVO} from '../../../../generate/ChangeVO';

@Component({
  selector: 'sponsoring-org-view',
  templateUrl: './sponsoring-org-view.component.html',
  styleUrls: ['./sponsoring-org-view.component.scss']
})
export class SponsoringOrgViewComponent implements OnInit {

  @Input()
  organizationVO: OrganizationVO;

  @Input()
  viewMode: boolean;

  @Input()
  lastchange: string;

  @Input()
  change: ChangeVO;

  @Input()
  pendingRequestChangeID: string;

  @Output()
  edit = new EventEmitter<boolean>();

  constructor() {
  }

  ngOnInit() {
  }

  onEdit(): void {
    this.edit.emit(true);
  }

}
